@if (editing()) {
  <input
    #headerInput
    class="header-input"
    [ngModel]="headerName()"
    (ngModelChange)="headerName.set($event)"
    (blur)="commitEdit()"
    (keydown)="onKeyDown($event)"
  />
} @else {
  <span class="header-label" [title]="headerName()">{{ headerName() }}</span>
}

<button
  class="type-icon"
  [class.type-icon--active]="isActive()"
  [class.type-icon--editable]="isEditable()"
  [title]="typeLabel()"
  (click)="toggleTypePicker($event)"
>
  {{ typeIcon() }}
</button>

@if (typePickerVisible()) {
  <div class="type-picker-backdrop" (click)="$event.stopPropagation(); hideTypePicker()"></div>
  <div
    class="type-picker"
    (click)="$event.stopPropagation()"
    [style.left.px]="typePickerPos().x"
    [style.top.px]="typePickerPos().y"
  >
    <button
      class="type-picker-item"
      [class.type-picker-item--active]="colType() === 'number'"
      (click)="selectType('number')"
    >
      <span class="type-picker-icon">#</span> Number
    </button>
    <button
      class="type-picker-item"
      [class.type-picker-item--active]="colType() === 'text'"
      (click)="selectType('text')"
    >
      <span class="type-picker-icon">Aa</span> Text
    </button>
    <button
      class="type-picker-item"
      [class.type-picker-item--active]="colType() === 'boolean'"
      (click)="selectType('boolean')"
    >
      <span class="type-picker-icon">T/F</span> True / False
    </button>
  </div>
}

@if (contextMenuVisible()) {
  <div class="context-menu-backdrop" (click)="$event.stopPropagation(); hideContextMenu()"></div>
  <div
    class="context-menu"
    (click)="$event.stopPropagation()"
    [style.left.px]="contextMenuPos().x"
    [style.top.px]="contextMenuPos().y"
  >
    @if (isEditable()) {
      <button class="context-menu-item" (click)="renameFromMenu()">Rename</button>
      <button class="context-menu-item context-menu-item--danger" (click)="deleteColumn()">Delete Column</button>
    } @else {
      <button class="context-menu-item" (click)="sortAscending()">Sort Ascending</button>
      <button class="context-menu-item" (click)="sortDescending()">Sort Descending</button>
    }
  </div>
}
